// Vendors
import { ReactChildrenType } from '@gruposantander/opbpay-ui-core-models';
import React from 'react';
import { IntlProvider } from 'react-intl';
// Hooks
import { useInternationalizationHook } from './hooks/internationalization.hook';

const InternationalizationProvider = ({ children }: ReactChildrenType): React.ReactNode | null => {
  const { fetching, locale, translations: messages } = useInternationalizationHook();

  return fetching ? null : (
    <IntlProvider
      {...{ locale, messages }}
      onError={(err): any => {
        if (err.code === 'MISSING_TRANSLATION') {
          window.console.warn(err);
          return;
        }
        window.console.info(err);
      }}
      onWarn={(warn: string) => {
        window.console.info(warn);
      }}
    >
      {children}
    </IntlProvider>
  );
};

export { InternationalizationProvider };
